import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { CircularProgress } from 'material-ui/Progress';
import Slide from 'material-ui/transitions/Slide';
import TextField from 'material-ui/TextField';
import { filter } from 'lodash'

import find from 'lodash/find'
import TableCell from './tablecell'

import * as color from '../../selectcolor'
import * as publish from '../../../actions/meetingdetails';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class AgendaDetails extends Component {

    handleRequestClose = () => {
        this.props.closeDialog();
    };

    setData = () => {
        // this.props.closeDialog();
        // this.props.actions.deleteMeetingDetailsar(this.props.id);
    };

    render() {
        const { id, meetingDetails, agendaitemmeetingDetails } = this.props;
        let result = null;
        if (meetingDetails && meetingDetails.Status) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        let _fileList = null
        // console.log('this.state.document.fileCDS', this.state.document.fileCDS)
        const fileList = this.props.agendaitemmeetingDetails ? this.props.agendaitemmeetingDetails.fileres : null;
        if (fileList && fileList.length > 0) {
            _fileList = fileList.map((_data, index) => {
                return (<TableCell key={index} data={_data} index={index} />);
            })
        }
        let colorValue = null;
        colorValue = filter(color.colorList, { 'value': agendaitemmeetingDetails ? agendaitemmeetingDetails.color : '' })
        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Agenda Details</span>
                    </DialogTitle>
                    <DialogContent>
                        {result}
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-12 pt-4">
                                        <TextField margin="normal" className="mt-0 col-md-12"
                                            name="name" label="Agenda Item Name"
                                            value={agendaitemmeetingDetails ? agendaitemmeetingDetails.name : ''} />
                                    </div>
                                    <div className="col-12">
                                        <TextField margin="normal" className="mt-0 col-md-12"
                                            name="meetingName" label="Meeting Name"
                                            value={agendaitemmeetingDetails ? agendaitemmeetingDetails.meetingName : ''} />
                                    </div>
                                    <div className="col-6">
                                        <TextField margin="normal" className="mt-0 col-md-12"
                                            name="headedBy" label="Headed By"
                                            value={agendaitemmeetingDetails ? agendaitemmeetingDetails.headedBy : ''} />
                                    </div>
                                    <div className="col-6">
                                        <TextField margin="normal" className="mt-0 col-md-12"
                                            name="color" label="Color Code"
                                            value={colorValue && colorValue.length > 0 ? colorValue[0].label : ''} />
                                    </div>
                                    <div className="col-12">
                                        <TextField margin="normal" className="mt-0 col-md-12"
                                            name="description" label="Description"
                                            value={agendaitemmeetingDetails ? agendaitemmeetingDetails.description : ''} />
                                    </div>
                                    <div className="col-md-12">
                                        <div className="table-responsive-material">
                                            <table className="default-table table-unbordered table table-lg table-hover">
                                                <thead className="th-border-b">
                                                    <tr>
                                                        <th>S.No.</th>
                                                        <th>File Name</th>
                                                        <th>Description</th>
                                                        <th className="status-cell text-right">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {_fileList}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Close</Button>
                        {/* <Button onClick={this.setData} variant="raised" className="jr-btn bg-primary text-white">Delete</Button> */}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(publish, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AgendaDetails);


// WEBPACK FOOTER //
// ./app/archivedetails/agendalist/agendadetails.js